import { render, staticRenderFns } from "./CarregarArquivo.vue?vue&type=template&id=7c4a5420"
import script from "./CarregarArquivo.vue?vue&type=script&lang=js"
export * from "./CarregarArquivo.vue?vue&type=script&lang=js"
import style0 from "./CarregarArquivo.vue?vue&type=style&index=0&id=7c4a5420&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports